module.exports = __webpack_public_path__ + "static/media/tier-4.26abf044.jpg";